import { gql } from '@generated/gql';

const addHomeInsuranceRenewalDate = gql(`
  mutation SubmitHomeInsuranceRenewal($input: SubmitRenewalDateInput!) {
  submitHomeInsuranceRenewal(input: $input)
}
`);

const addCarInsuranceRenewalDate = gql(`
  mutation SubmitCarInsuranceRenewal($accountNumber: String!, $endDate: String!) {
    submitCarInsuranceRenewal(input: {
      accountNumber: $accountNumber
      endDate: $endDate
    })
  }
`);

const submitMobileRenewal = gql(`
  mutation SubmitMobileRenewal($accountNumber: String!, $endDate: String!) {
    submitMobileRenewal(input: {
      accountNumber: $accountNumber
      endDate: $endDate
    })
  }
`);

const submitBroadbandRenewal = gql(`
  mutation SubmitBroadbandRenewal($accountNumber: String!, $endDate: String!) {
    submitBroadbandRenewal(input: {
      accountNumber: $accountNumber
      endDate: $endDate
    })
  }
`);

export {
  addHomeInsuranceRenewalDate,
  addCarInsuranceRenewalDate,
  submitMobileRenewal,
  submitBroadbandRenewal,
};
